import { app } from '../../../../bootstrap/core';
import { ReceivingService } from './receiving.service';
import {
  ReceivingStates,
  ReceivingKwhTypes,
  ReceivingDataModifiers,
  ReceivingCreatedSuccessState,
  ReceivingSubmitValidationRules
} from './receiving.constants';
import './createRequest/createRequest';
import './confirmRequest/confirmRequest';
import './submitRequest/submitRequest';
import './successfulSubmit/successfulSubmit';

app.service('receivingService', ReceivingService);
app.value('ReceivingStates', ReceivingStates);
app.value('ReceivingKwhTypes', ReceivingKwhTypes);
app.constant('ReceivingDataModifiers', ReceivingDataModifiers);
app.constant('ReceivingCreatedSuccessState', ReceivingCreatedSuccessState);
app.constant('ReceivingSubmitValidationRules', ReceivingSubmitValidationRules);
